import { compose } from 'redux';
import TokenViewer from 'data-token-views/TokenViewer';
import { getFullyQualifiedName } from 'automation-ui-references/object-types/objectTypeUtils';
import SkeletonText from 'automation-ui-core/components/SkeletonText';
import { convertTokensToEditorFormat } from 'automation-ui-action-features/personalized-text/personalizedTextUtils';
import { adjustFqnCasing } from 'automation-ui-action-features/utils/tinymceUtils';
import { queryObjectTypeByPropertyTypeId } from 'automation-ui-references/object-type-properties/ObjectTypesQueries';
import FormulaTextLabel from 'automation-ui-formula-editor/formula-editor/data-passing/FormulaTextLabel';
import { isLegacyTokenPrefix } from 'automation-ui-formula-editor/data-sources/utils/isLegacyTokenPrefix';
import getTokenParts from 'automation-ui-formula-editor/data-sources/utils/getTokenParts';
import { jsx as _jsx } from "react/jsx-runtime";
const PersonalizedTextView = ({
  objectTypeDefinition,
  objectTypeDefinitionLoading,
  propertyTypeId,
  text
}) => {
  const propertyObjectFQN = getFullyQualifiedName(objectTypeDefinition);
  if (!propertyObjectFQN || objectTypeDefinitionLoading) {
    return /*#__PURE__*/_jsx(SkeletonText, {});
  }
  const normalizedPropertyObjectFQN = adjustFqnCasing(propertyObjectFQN);
  const value = convertTokensToEditorFormat(text, {
    propertyTypeId,
    propertyObjectFQN: normalizedPropertyObjectFQN
  });
  return /*#__PURE__*/_jsx(TokenViewer, {
    supportedCrmObjectFQNs: [normalizedPropertyObjectFQN],
    tagName: "span",
    value: value
  });
};
const withFormulaTextLabel = WrappedComponent => props => {
  const {
    prefix
  } = getTokenParts(props.text);
  const isLegacyToken = isLegacyTokenPrefix(prefix);
  if (!isLegacyToken) {
    return /*#__PURE__*/_jsx(FormulaTextLabel, {
      text: props.text
    });
  }
  return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props));
};
export default compose(withFormulaTextLabel, queryObjectTypeByPropertyTypeId)(PersonalizedTextView);